import C086DonationCardTeaserContainer from "../../content/C086DonationCardCollection/C086DonationCardTeaserContainer";
import CCOComment from "../../fundamentals/CCOComment";
import C003Download from "../../content/C003Download/C003Download";
import CCOContainer from "../../fundamentals/CCOContainer";
import C999E2ETest from "../../content/C999E2ETest/C999E2ETest";
import C000DefaultCollection from "../../content/C000Default/C000DefaultCollection";
import React from "react";
import C078ViewTypeImageText from "../../content/C078ViewTypeImageText/C078ViewTypeImageText";
import C069ContentTag from "../../content/C069ContentTag/C069ContentTag";
import dynamic from "next/dynamic";
import C075Hero from "../../content/C075Hero/C075Hero";
import C014StageCarousel from "../../content/C014StageCarousel/C014StageCarousel";
import {CmCollectionType} from "../../types";
import C090ImageTextTeaserGrid from "../../content/C090ImageTextTeaserGrid/C090ImageTextTeaserGrid";
import C092_3ColGrid from "../../content/C092_3ColGrid/C092_3ColGrid";
import C093TrustElementCollection from "../../content/C093TrustElementCollection/C093TrustElementCollection";

interface Props {
    item: CmCollectionType,
    CAEGlobalSettings: any,
    richTextItemId?: string
}

const C001Accordion = dynamic(() => import('../../content/C001Accordion/C001Accordion'), {
    ssr: false
})
const C004Tabs = dynamic(() => import('../../content/C004Tabs/C004Tabs'))
const C006DonationLine = dynamic(() => import('../../content/C006DonationLine/C006DonationLine'), {
    ssr: false
})
const C009Storytelling = dynamic(() => import('../../content/C009Storytelling/C009Storytelling'), {
    ssr: false
})
const C010Facts = dynamic(() => import('../../content/C010Facts/C010Facts'))
const C011Counter = dynamic(() => import('../../content/C011Counter/C011Counter'))
const C013FAQ = dynamic(() => import('../../content/C013FAQ/C013FAQ'))
const C079ViewTypeVideo = dynamic(() => import('../../content/C079ViewTypeVideo/C079ViewTypeVideo'))
const C016GlobalFilter = dynamic(() => import('../../content/C016GlobalFilter/C016GlobalFilter'), {
    ssr: false
})
const C008ImageGallery = dynamic(() => import('../../content/C008ImageGallery/C008ImageGallery'), {
    ssr: false
})
const C068TeaserMasonry = dynamic(() => import('../../content/C068TeaserMasonry/C068TeaserMasonry'))
const C068TeaserMasonryDeprecated = dynamic(() => import('../../content/C068TeaserMasonry/C068TeaserMasonryDeprecated'))
const C015QuoteCarousel = dynamic(() => import('../../content/C015QuoteCarousel/C015QuoteCarousel'), {
    ssr: false
})
const C020TeaserCarousel = dynamic(() => import('../../content/C020TeaserCarousel/C020TeaserCarousel'), {
    ssr: false
})
const C021KachelTeaser = dynamic(() => import('../../content/C021KachelTeaser/C021KachelTeaser'))
const C021KachelTeaserDeprecated = dynamic(() => import('../../content/C021KachelTeaser/C021KachelTeaserDeprecated'))

function CollectionViewType(props: Props) {
    const item = props.item;
    const cmCollection = item as CmCollectionType;
    switch (item.viewtype) {
        // Hier können weitere viewtypes hinzugefügt werden
        case 'c001_accordion': {
            return <CCOComment text='REACT=cmCollection.C001Accordion,CM=accordion'>
                <C001Accordion cmCollection={cmCollection} layoutSettings={item.layoutSettings}/>
            </CCOComment>
        }
        case 'c003_download': {
            return <CCOComment text='REACT=cmCollection.C003Download,CM=c003_download'>
                <C003Download cmCollection={cmCollection} layoutSettings={item.layoutSettings}/>
            </CCOComment>
        }
        case 'c004_tabs': {
            return <CCOComment text='REACT=cmCollection.C004Tabs,CM=c004_tabs'>
                <C004Tabs cmCollection={cmCollection} layoutSettings={item.layoutSettings}/>
            </CCOComment>
        }
        case 'c006_donation_line': {
            return <CCOComment text='REACT=cmCollection.C006DonationLine,CM=c006_donation_line'>
                <C006DonationLine cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c009_storytelling': {
            return <CCOComment text='REACT=cmCollection.C009Storytelling,CM=c009_storytelling'>
                <C009Storytelling cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c010_facts': {
            return <CCOComment text='REACT=cmCollection.C010Facts,CM=c010_facts'>
                <C010Facts cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c011_counter': {
            return <CCOComment text='REACT=cmCollection.C011Counter,CM=c011_counter'>
                <C011Counter cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c013_faq': {
            return <CCOComment text='REACT=cmCollection.C013FAQ,CM=c013_faq'>
                <C013FAQ cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c014_stage_carousel': {
            return <CCOComment text='REACT=cmCollection.C014StageCarousel,CM=c014_stage_carousel'>
                <C014StageCarousel cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c015_quote_carousel': {
            return <CCOComment text='REACT=cmCollection.C015QuoteCarousel,CM=c015_quote_carousel'>
                <C015QuoteCarousel cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c020_teaser_carousel': {
            return <CCOComment text='REACT=cmCollection.C020TeaserCarousel,CM=c020_teaser_carousel'>
                <C020TeaserCarousel cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c020_teaser_carousel_with_products': {
            return <CCOComment text='REACT=cmCollection.C020TeaserCarousel,CM=c020_teaser_carousel_with_products'>
                <C020TeaserCarousel cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c086_donation_card_collection': {
            return <CCOComment text='REACT=cmCollection.C086DonationCardCollection,CM=c086_donation_card_collection'>
                <C086DonationCardTeaserContainer cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c021_kachel_teaser': {
            return <CCOComment text='REACT=cmCollection.C021KachelTeaser,CM=c021_kachel_teaser'>
                <C021KachelTeaser cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c021_kachel_teaser_deprecated': {
            return <CCOComment text='REACT=cmCollection.C021KachelTeaserDeprecated,CM=c021_kachel_teaser_deprecated'>
                <C021KachelTeaserDeprecated cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c068_teaser_masonry': {
            return <CCOComment text='REACT=cmCollection.C068TeaserMasonry,CM=c068_teaser_masonry'>
                <C068TeaserMasonry cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c068_teaser_masonry_deprecated': {
            return <CCOComment text='REACT=cmCollection.C068TeaserMasonryDeprecated,CM=c068_teaser_masonry_deprecated'>
                <C068TeaserMasonryDeprecated cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c075_hero': {
            return <CCOComment text='REACT=cmCollection.C075Hero,CM=c075_hero'>
                <C075Hero cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c021_kachel_teaser_with_special_topics': {
            return <CCOComment text='REACT=cmCollection.C021KachelTeaser,CM=c021_kachel_teaser_with_special_topics'>
                <CCOContainer width={"full"}>
                    <C021KachelTeaser cmCollection={cmCollection} useSquareImage={true}/>
                </CCOContainer>
            </CCOComment>
        }
        case 'c008_image_gallery': {
            return <CCOComment text='REACT=cmCollection.C008ImageGallery,CM=c008_image_gallery'>
                <C008ImageGallery gallery={cmCollection}
                                  isRichText={props.richTextItemId !== undefined}/>
            </CCOComment>
        }
        case 'c016_global_filter': {
            return <CCOComment text='REACT=cmCollection.C016GlobalFilter,CM=c016_global_filter'>
                <C016GlobalFilter cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c078_view_type_image_text_left':
        case 'c078_view_type_image_text_left_right': {
            return <CCOComment
                text='REACT=cmCollection.C078ViewTypeImageText,CM=c078_view_type_image_text_left|c078_view_type_image_text_left_right'>
                <C078ViewTypeImageText cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c079_view_type_video': {
            return <CCOComment text='REACT=cmCollection.C079ViewTypeVideo,CM=c079_view_type_video'>
                <C079ViewTypeVideo cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c069_content_tag': {
            return <CCOComment text='REACT=cmCollection.C069ContentTag,CM=c069_content_tag'>
                <C069ContentTag cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c089_image_text_teaser_grid': {
            return <CCOComment text='REACT=cmCollection.C090ImageTextTeaserGrid,CM=gridImageTextTeaser'>
                <C090ImageTextTeaserGrid cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c092_3col-grid': {
            return <CCOComment text='REACT=cmCollection.C092LinkedImageGrid,CM=c092_linked_image_grid'>
                <C092_3ColGrid cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c093_trust_element_collection': {
            return <CCOComment text='REACT=cmCollection.C093TrustElementCollection,CM=c093_trust_element_collection'>
                <C093TrustElementCollection cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'e2etest': {
            return <C999E2ETest cmCollection={cmCollection}/>
        }
        default: {
            return <CCOComment text='cmCollection.C000DefaultCollection'>
                <C000DefaultCollection cmCollection={cmCollection}/>
            </CCOComment>
        }
    }
}

export default CollectionViewType
